
import React from 'react';
import { 
  Building2, 
  CreditCard, 
  Layers, 
  Users, 
  Shield, 
  BarChart3,
  Puzzle,
  Database
} from 'lucide-react';
import FadeInSection from '../ui/FadeInSection';
import GlassCard from '../ui/GlassCard';
import { useLanguage } from '@/components/i18n/language-provider';

const FeaturesSection: React.FC = () => {
  const { t } = useLanguage();

  const features = [
    {
      title: t('features.multiOrg'),
      description: t('features.multiOrgDesc'),
      icon: Building2,
      delay: 0
    },
    {
      title: t('features.billing'),
      description: t('features.billingDesc'),
      icon: CreditCard,
      delay: 100
    },
    {
      title: t('features.access'),
      description: t('features.accessDesc'),
      icon: Layers,
      delay: 200
    },
    {
      title: t('features.roles'),
      description: t('features.rolesDesc'),
      icon: Users,
      delay: 300
    },
    {
      title: t('features.identityDirectory'),
      description: t('features.identityDirectoryDesc'),
      icon: Database,
      delay: 400
    },
    {
      title: t('features.analytics'),
      description: t('features.analyticsDesc'),
      icon: BarChart3,
      delay: 500
    },
    {
      title: t('features.integration'),
      description: t('features.integrationDesc'),
      icon: Puzzle,
      delay: 600
    },
    {
      title: t('features.multiTenant'),
      description: t('features.multiTenantDesc'),
      icon: Shield,
      delay: 700
    }
  ];

  return (
    <section className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <FadeInSection>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              {t('features.title')}
            </h2>
          </FadeInSection>
          <FadeInSection delay={100}>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t('features.description')}
            </p>
          </FadeInSection>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FadeInSection key={index} delay={feature.delay} direction="up">
              <GlassCard className="h-full" hoverEffect>
                <div className="mb-4 p-2 w-12 h-12 flex items-center justify-center rounded-lg bg-brand-pink/10">
                  <feature.icon className="h-6 w-6 text-brand-pink" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </GlassCard>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
